import reducers from './reducers';

export {
    actions as checkoutTermsOperations,
    default as checkoutTermsSaga,
} from './operations';

export default reducers;
